import { useState } from "react";
import { Outlet } from "react-router-dom";
import { Topbar } from "@/components/layout/Topbar";
import { OperationalSidebar } from "@/components/layout/OperationalSidebar";
import { useIsMobile } from "@/hooks/use-mobile";
import { cn } from "@/lib/utils";

export function OperationalLayout() {
  const [collapsed, setCollapsed] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const isMobile = useIsMobile();

  return (
    <div className="min-h-screen bg-background">
      <OperationalSidebar
        collapsed={collapsed}
        isMobile={isMobile}
        mobileOpen={mobileOpen}
        onCloseMobile={() => setMobileOpen(false)}
        onToggle={() => (isMobile ? setMobileOpen((prev) => !prev) : setCollapsed(!collapsed))}
      />
      <div className={cn("min-w-0 transition-all duration-300", !isMobile && (collapsed ? "md:ml-16" : "md:ml-[260px]"))}>
        <Topbar onMenuClick={() => (isMobile ? setMobileOpen((prev) => !prev) : setCollapsed(!collapsed))} />
        <main className="min-w-0 p-4 sm:p-6">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
